interface OptionLegInfoProps {
  strikeAndType: string;
  expirationDate: string;
  contractPrice: string;
}

export const OptionLegInfo = ({
  strikeAndType,
  expirationDate,
  contractPrice,
}: OptionLegInfoProps) => (
  <div className="flex w-full items-center justify-between">
    <div className="flex min-w-0 flex-1 items-center gap-1">
      <span className="whitespace-nowrap font-semibold text-gray-700 text-sm leading-5">
        {strikeAndType}
      </span>
      <span className="whitespace-nowrap font-semibold text-gray-700 text-sm leading-5">
        {expirationDate}
      </span>
    </div>
    <span className="whitespace-nowrap font-mono font-normal text-gray-800 text-sm leading-5">
      {contractPrice}
    </span>
  </div>
);
